const toggleSubMenuClass = (element, toggle) => {
  const parentElem = element.closest('.menu__item');
  parentElem?.classList.toggle('is-open-submenu', toggle);
};

// Toggle submenu on arrow click
attachEvent('.menu__arrow', 'click', (ev) => {
  const parentElem = ev.target.closest('.menu__item');
  if (!parentElem) return;

  const isOpen = parentElem.classList.contains('is-open-submenu');
  toggleSubMenuClass(parentElem, !isOpen);
});

// Close submenu on back button click
attachEvent('.menu__back', 'click', (ev) => {
  const parentElem = ev.target.closest('.menu__item');
  if (parentElem) {
    toggleSubMenuClass(parentElem, false);
  }
});

// Close submenu on outside click
document.addEventListener('click', (ev) => {
  document.querySelectorAll('.menu__item.is-open-submenu').forEach((item) => {
    if (!item.contains(ev.target)) {
      toggleSubMenuClass(item, false);
    }
  });
});

// Close submenu on ESC key press
onKeydown('Escape', () => {
  document.querySelectorAll('.menu__item.is-open-submenu').forEach((item) => toggleSubMenuClass(item, false));
});
